// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import { useRouter } from "next/router";
import { useTheme } from "@mui/material";

import { Typography, Grid, Link } from "@/components/core";
import useTranslation from "next-translate/useTranslation";

export function Footer() {
  const theme = useTheme();
  const today = new Date();
  const router = useRouter();
  const { t } = useTranslation("common");

  const isMoneyTransferPage = router.pathname === "/money-transfer";
  const isLoginPage = router.pathname === "/login" || router.pathname === "/register";

  const footerStyle = {
    background: `${isLoginPage ? theme.palette.background.gradient : theme.palette.text.contrast} `,
    color: `${isLoginPage ? "white" : "black"} `,
    padding: 20,
    textAlign: "left",
    bottom: 0,
    left: 0,
    width: "100%",
    margin: "0",
    position: isMoneyTransferPage ? "fixed" : "static",
  };

  return (
    <footer style={footerStyle}>
      <Grid>
        <Grid.Item xs={12} md={12}>
          {isLoginPage ? (
            <Typography sx={{ fontSize: "12px" }}>{t("policymessage")}</Typography>
          ) : (
            <Typography
              textAlign={{
                xs: "center",
                md: "left",
              }}
            >
              © {today.getFullYear()} UPT Ödeme Hizmetleri ve Elektronik Para A.Ş.
            </Typography>
          )}
        </Grid.Item>
      </Grid>
    </footer>
  );
}
